import { motion, useSpring } from "framer-motion";
import { useEffect } from "react";
import {
  introDialogue,
  guidedBattle,
  firstDeck,
} from "../@shared/utils/tutorialSequenceSteps";

const orbSize = 80;

const TutorialInfinityOrb = ({ currentSequence }) => {
  // Vertical hover effect
  const ySpring = useSpring(0, {
    stiffness: 60,
    damping: 15,
  });

  //   const IOStyle =
  //     currentSequence === "introDialogue"
  //       ? {}
  //       : currentSequence === "guidedBattle"
  //       ? {
  //           right: "5%",
  //           top: "20%",
  //           scale: 2,
  //           y: ySpring,
  //           width: orbSize,
  //           height: orbSize,
  //         }
  //       : {};

  const IOFrame =
    currentSequence === "introDialogue"
      ? "0px 0px"
      : currentSequence === "guidedBattle"
      ? "-76px 0px"
      : "0px 0px";
  //   currentSequence === "firstDeck" ? '-152px 0px' :

  useEffect(() => {
    // Oscillate between -5 and 5 on the y-axis
    const loop = () => {
      ySpring.set(-5);
      setTimeout(() => ySpring.set(5), 500);
    };
    loop(); // start immediately
    const interval = setInterval(loop, 1000);
    return () => clearInterval(interval);
  }, [ySpring]);

  return (
    <motion.div
      style={{
        // ...IOStyle,
        position: "absolute",
        left: "50%",
        top: "50%",
        x: "-50%",
        y: ySpring,
        width: orbSize,
        height: orbSize,
        zIndex: 9999,
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Sprite - static front-facing frame */}
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundImage: `url(${require("../@shared/assets/sprites/infinityOrb-ns-sprite.png")})`,
            backgroundPosition: IOFrame, // first frame
            backgroundRepeat: "no-repeat",
            backgroundSize: `${orbSize * 4}px ${orbSize}px`,
            zIndex: 2,
          }}
        />

        {/* Glow layer */}
        <div
          style={{
            width: "50%",
            height: "58%",
            position: "absolute",
            top: "50%",
            left: "54%",
            transform: "translate(-50%, -50%)",
            background:
              "radial-gradient(rgb(116, 249, 116), rgba(0, 41, 0, 0.8))",
            borderRadius: "50%",
            zIndex: 1,
          }}
        />
      </div>
    </motion.div>
  );
};

export default TutorialInfinityOrb;
